import { useEffect, useState } from 'react';
import { useI18n } from '@/ui/i18n/I18nProvider';
import { canAddToHomeScreen } from '@/ui/util/install';
import styles from './UpdatePrompt.module.css';

const LAUNCHES_KEY = 'lct.launches';
const SNOOZE_KEY = 'lct.installHintSnooze';
/** "Để sau" keeps it quiet for a few days; Settings always has the steps. */
const SNOOZE_MS = 3 * 24 * 60 * 60_000;
/** A little after the room is up, never on top of the first-time tutorial (from the second launch on). */
const DELAY_MS = 20_000;

function read(key: string): number {
  try {
    return Number(localStorage.getItem(key) ?? 0);
  } catch {
    return 0;
  }
}

function write(key: string, value: number): void {
  try {
    localStorage.setItem(key, String(value));
  } catch {
    /* Private mode: the hint just shows again next time. */
  }
}

/** iOS Safari has no install prompt: suggest "Thêm vào MH chính" so the game opens full screen with its icon. */
export function InstallHint({ ready }: { ready: boolean }) {
  const { t } = useI18n();
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (!ready || !canAddToHomeScreen()) return;
    const launches = read(LAUNCHES_KEY) + 1;
    write(LAUNCHES_KEY, launches);
    if (launches < 2 || Date.now() < read(SNOOZE_KEY)) return;
    const timer = setTimeout(() => {
      setShow(true);
    }, DELAY_MS);
    return () => {
      clearTimeout(timer);
    };
  }, [ready]);

  if (!show) return null;
  return (
    <div className={styles.toast} role="status" data-testid="install-hint">
      <span>{t('ui.install.ios_hint')}</span>
      <button
        type="button"
        className={styles.later}
        onClick={() => {
          write(SNOOZE_KEY, Date.now() + SNOOZE_MS);
          setShow(false);
        }}
      >
        {t('ui.install.ok')}
      </button>
    </div>
  );
}
